var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteAction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.765 5.25c0-.207.168-.375.375-.375h2.112c.207 0 .375.168.375.375v.318H7.765V5.25zm-.75.318V5.25c0-.621.504-1.125 1.125-1.125h2.112c.621 0 1.125.504 1.125 1.125v.318h2.513a.375.375 0 010 .75h-.722l-.191 6.487a1.875 1.875 0 01-1.874 1.82H7.282a1.875 1.875 0 01-1.874-1.82l-.191-6.487H4.5a.375.375 0 010-.75h2.515zm-1.048.75h6.45l-.19 6.464a1.125 1.125 0 01-1.124 1.092H7.282a1.125 1.125 0 01-1.125-1.092l-.19-6.464zm2.147.878c.207 0 .375.168.375.375v4.334a.375.375 0 01-.75 0V7.57c0-.207.168-.375.375-.375zm2.54.375a.375.375 0 00-.75 0v4.334a.375.375 0 10.75 0V7.57z",
    fill: "#EC4652"
  })));
}
export default SvgDeleteAction;